import { SET_LOCAL_SETTINGS_TABLE, GET_LOCAL_SETTINGS_TABLE } from 'fixtures/actions'
import { getSettingsTableLocal, setSettingsTableLocal } from 'utils/localData/settingstable'

export const getLocalSettingsTableData = () => {
  return dispatch => {
    getSettingsTableLocal((data) => {
      dispatch({
        type: GET_LOCAL_SETTINGS_TABLE,
        payload: data
      })
    })
  }
}

export const setLocalSettingsTableData = (data) => {
  return dispatch => {
    setSettingsTableLocal(data)

    dispatch({
      type: SET_LOCAL_SETTINGS_TABLE,
      payload: data
    })
  }
}